import { render, staticRenderFns } from "./PremiumServices.vue?vue&type=template&id=3fc41d08&scoped=true&"
import script from "./PremiumServices.vue?vue&type=script&lang=js&"
export * from "./PremiumServices.vue?vue&type=script&lang=js&"
import style0 from "./PremiumServices.vue?vue&type=style&index=0&id=3fc41d08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc41d08",
  null
  
)

export default component.exports